import React, { useEffect, useRef } from 'react'
import { Trans } from 'react-i18next'
import Flex from 'typescript-styled-flex'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import { is, Mobile } from '../MediaQuery'
import Modal, {
  CloseButton,
  ModalHeader,
  ModalHeaderLabel,
} from '../Template/Modal'

function Content({ children }) {
  const divRef = useRef(null as HTMLDivElement)

  useEffect(() => {
    if (divRef) {
      disableBodyScroll(divRef.current)
    } else {
      enableBodyScroll(divRef.current)
    }
    return () => {
      // eslint-disable-next-line
      if (divRef) {
        // eslint-disable-next-line
        enableBodyScroll(divRef.current)
      }
    }
  }, [divRef])

  return (
    <>
      <Mobile>
        <div
          style={{
            maxHeight: 'calc(calc(var(--full) - 5vh) - 90px)',
            overflowX: 'hidden',
            overflowY: 'auto',
            paddingRight: '15px',
          }}
          ref={divRef}
        >
          {children}
        </div>
      </Mobile>
    </>
  )
}

function UpgradePremiumModal({
                        open,
                        close,
                        children,
                        buttons,
                      }: IPremiumModalProps & IPremiumModalDispatch) {
  const isDesktop = is.desktop()

  return (
    <Modal
      open={open}
      onClose={close}
      style={{
        maxHeight: isDesktop ? 'unset' : 'calc(var(--full) - 5%)',
        borderRadius: '6px 6px 0 0',
        overflow: 'hidden',
        padding: isDesktop ? '20px' : '15px',
        paddingRight: isDesktop ? '20px' : '0px',
        paddingTop: isDesktop ? '15px' : '5px',
        width: isDesktop ? '950px' : '520px',

      }}
      containerStyle={{
        alignItems: 'flex-end',
        background: 'rgba(0, 0, 0, 0.15)',
      }}
    >
      <Content>
        <ModalHeader style={{ paddingBottom: '1em' }}>
          <Flex full={true} justifyBetween={true}>
            <ModalHeaderLabel>
              <Trans i18nKey={'premium'}></Trans>
            </ModalHeaderLabel>
            <CloseButton style={{ marginRight: '-15px' }} onClose={close}/>
          </Flex>
        </ModalHeader>

        {children}
      </Content>

      <Flex
        style={{ paddingRight: isDesktop ? '0px' : '15px' }}
        justifyCenter={true}
      >
        {buttons}
      </Flex>
    </Modal>
  )
}

export default UpgradePremiumModal

export interface IPremiumModalProps {
  open: boolean
  children?: React.ReactNode
  buttons?: React.ReactNode
}

export interface IPremiumModalDispatch {
  close: () => void
}
